(() => {
  'use strict';
  if (window.MelcoWishlist) return;
  const KEY = `melco:wishlist:v1:${location.hostname}`;
  const MAX_ITEMS = 100;
  const CARD_SELECTOR = '.m7-product-card, .m7-look-product, .r9-card[data-review-product]';
  const prepared = new WeakSet();
  const cards = new Map();
  let frame = 0;
  let restoreFocus = null;
  let storageAvailable = true;
  let dialog;
  let list;
  let empty;
  let status;

  function safeLink(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections)\//i.test(url.pathname)) return '';
      return url.pathname + url.search + url.hash;
    } catch (_) { return ''; }
  }
  function safeImage(value) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' || url.origin === location.origin ? url.href : '';
    } catch (_) { return ''; }
  }
  function identity(link, code) {
    const supplied = String(code || '').trim().toUpperCase();
    if (/^MC-\d{2,3}$/.test(supplied)) return supplied;
    try {
      const url = new URL(link, location.origin);
      const galleryCode = new URLSearchParams(url.hash.slice(1)).get('urun');
      if (/^MC-\d{2,3}$/i.test(galleryCode || '')) return galleryCode.toUpperCase();
      const handle = url.pathname.match(/\/products\/([^/]+)\/?$/i);
      return handle ? `product:${handle[1].toLowerCase()}` : '';
    } catch (_) { return ''; }
  }
  function normalizeItem(raw) {
    if (!raw || typeof raw !== 'object') return null;
    const url = safeLink(raw.url);
    const id = identity(url, raw.id);
    const title = typeof raw.title === 'string' ? raw.title.trim().slice(0, 240) : '';
    return url && id && title ? {id, title, url, image: safeImage(raw.image)} : null;
  }
  function decode(value) {
    const result = new Map();
    try {
      const parsed = JSON.parse(value || 'null');
      if (parsed?.version !== 1 || !Array.isArray(parsed.items)) return result;
      for (const raw of parsed.items.slice(0, MAX_ITEMS)) {
        const item = normalizeItem(raw);
        if (item) result.set(item.id, item);
      }
    } catch (_) { /* Ignore a corrupted or outdated saved list. */ }
    return result;
  }
  let saved;
  try { saved = decode(localStorage.getItem(KEY)); }
  catch (_) { saved = new Map(); storageAvailable = false; }

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function heart() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 28 28');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M14 24S3 17 3 9.5C3 3.5 10.5 2 14 7c3.5-5 11-3.5 11 2.5C25 17 14 24 14 24Z');
    svg.append(path);
    return svg;
  }
  function announce(message) {
    status.textContent = message;
  }
  function persist() {
    try {
      localStorage.setItem(KEY, JSON.stringify({version: 1, items: [...saved.values()]}));
      storageAvailable = true;
    } catch (_) { storageAvailable = false; }
  }
  function refreshButtons() {
    for (const [button, item] of cards) {
      if (!button.isConnected) { cards.delete(button); continue; }
      const selected = saved.has(item.id);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${item.title}: ${selected ? 'favorilerden çıkar' : 'favorilere ekle'}`);
      button.title = selected ? 'Favorilerden çıkar' : 'Favorilere ekle';
    }
    document.querySelectorAll('[data-melco-wishlist-open]').forEach(button => {
      button.setAttribute('aria-controls', 'MelcoWishlistDialog');
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-expanded', String(Boolean(dialog?.open)));
      button.setAttribute('aria-label', saved.size ? `Favorilerim, ${saved.size} ürün` : 'Favorilerim');
    });
    document.querySelectorAll('[data-melco-wishlist-count]').forEach(count => {
      count.textContent = saved.size ? String(saved.size) : '';
      count.hidden = !saved.size;
    });
  }
  function updateSaved(item) {
    const selected = saved.has(item.id);
    if (selected) saved.delete(item.id);
    else {
      if (saved.size >= MAX_ITEMS) { announce('Favori listeniz dolu. Yeni bir ürün eklemek için bir ürünü çıkarın.'); return; }
      saved.set(item.id, item);
    }
    persist();
    refreshButtons();
    if (dialog.open) renderList();
    announce(`${item.title} ${selected ? 'favorilerinizden çıkarıldı.' : 'favorilerinize eklendi.'}${storageAvailable ? '' : ' Favoriler bu oturumda saklanıyor.'}`);
  }
  function renderList(focusId) {
    list.replaceChildren();
    empty.hidden = saved.size > 0;
    for (const item of saved.values()) {
      const row = el('li', 'melco-wishlist__item');
      const link = el('a', 'melco-wishlist__product');
      link.href = item.url;
      const media = el('span', 'melco-wishlist__image');
      if (item.image) {
        const image = el('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 90;
        image.height = 120;
        media.append(image);
      }
      const copy = el('span', 'melco-wishlist__copy');
      copy.append(el('span', 'melco-wishlist__name', item.title), el('span', 'melco-wishlist__view', 'Ürünü incele ↗'));
      link.append(media, copy);
      link.addEventListener('click', () => dialog.close());
      const remove = el('button', 'melco-wishlist__remove', 'Kaldır');
      remove.type = 'button';
      remove.dataset.removeId = item.id;
      remove.setAttribute('aria-label', `${item.title}: favorilerden çıkar`);
      remove.addEventListener('click', () => {
        const ids = [...saved.keys()];
        const position = ids.indexOf(item.id);
        const nextId = ids[position + 1] || ids[position - 1];
        saved.delete(item.id);
        persist();
        refreshButtons();
        renderList(nextId);
        announce(`${item.title} favorilerinizden çıkarıldı.`);
      });
      row.append(link, remove);
      list.append(row);
    }
    if (focusId) [...list.querySelectorAll('[data-remove-id]')].find(button => button.dataset.removeId === focusId)?.focus();
    else if (!saved.size && dialog.open) dialog.querySelector('[data-wishlist-close]').focus();
  }
  function openList(source) {
    if (dialog.open) return;
    restoreFocus = source;
    renderList();
    dialog.showModal();
    document.documentElement.classList.add('melco-wishlist-open');
    refreshButtons();
    dialog.querySelector('[data-wishlist-close]').focus();
  }
  function buildDialog() {
    status = el('p', 'melco-wishlist__status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    dialog = el('dialog', 'melco-wishlist');
    dialog.id = 'MelcoWishlistDialog';
    dialog.setAttribute('aria-labelledby', 'MelcoWishlistTitle');
    const head = el('div', 'melco-wishlist__head');
    const title = el('h2', '', 'Favorilerim');
    title.id = 'MelcoWishlistTitle';
    const close = el('button', 'melco-wishlist__close', '×');
    close.type = 'button';
    close.dataset.wishlistClose = '';
    close.setAttribute('aria-label', 'Favorilerimi kapat');
    close.addEventListener('click', () => dialog.close());
    head.append(title, close);
    empty = el('div', 'melco-wishlist__empty');
    empty.append(heart(), el('p', '', 'Henüz favoriniz yok.'), el('p', 'melco-wishlist__hint', 'Beğendiğiniz ürünlerin kalbine dokunarak kendi seçkinizi oluşturun.'));
    list = el('ul', 'melco-wishlist__list');
    list.setAttribute('aria-label', 'Favori ürünler');
    const body = el('div', 'melco-wishlist__body');
    body.append(empty, list);
    dialog.append(head, body);
    document.body.append(dialog, status);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('melco-wishlist-open');
      refreshButtons();
      if (restoreFocus?.isConnected) restoreFocus.focus({preventScroll: true});
    });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled])')].filter(node => !node.hidden && node.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
  }

  function prepareCard(card) {
    if (prepared.has(card)) return;
    const legacy = card.matches('.r9-card');
    const mini = card.matches('.m7-look-product');
    const code = card.dataset.melcoProductCode || card.dataset.reviewProduct;
    const url = legacy ? `/collections/all#urun=${encodeURIComponent(code)}` : card.getAttribute('href');
    const name = card.querySelector(legacy ? '.r9-card-name' : 'h3');
    const image = card.querySelector(legacy ? '.r9-card-media img' : 'img');
    const item = normalizeItem({id: code, url, title: name?.textContent || '', image: image?.currentSrc || image?.src || ''});
    if (!item) return;
    let holder = legacy ? card : card.parentElement;
    if (mini) {
      holder = el('div', 'melco-wishlist-look');
      card.before(holder);
      holder.append(card);
    }
    holder.classList.add('melco-wishlist-card');
    const button = el('button', 'melco-wishlist-toggle');
    button.type = 'button';
    button.dataset.melcoWishlistId = item.id;
    button.append(heart());
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      updateSaved(item);
    });
    holder.append(button);
    prepared.add(card);
    cards.set(button, item);
    if (!mini) {
      const media = card.querySelector(legacy ? '.r9-card-media' : '.m7-product-card__media');
      const position = () => {
        if (!button.isConnected || !media) return;
        const top = Math.max(0, media.getBoundingClientRect().bottom - holder.getBoundingClientRect().top + 3);
        button.style.top = `${Math.round(top)}px`;
      };
      position();
      if (window.ResizeObserver && media) {
        const observer = new ResizeObserver(() => {
          if (!button.isConnected) observer.disconnect();
          else position();
        });
        observer.observe(media);
      } else window.addEventListener('resize', position, {passive: true});
    }
  }
  function scan() {
    frame = 0;
    document.querySelectorAll(CARD_SELECTOR).forEach(prepareCard);
    refreshButtons();
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(scan);
  }
  function start() {
    buildDialog();
    scan();
    document.addEventListener('click', event => {
      const opener = event.target.closest('[data-melco-wishlist-open]');
      if (opener) { event.preventDefault(); openList(opener); }
    });
    const observer = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !node.closest?.('#MelcoWishlistDialog') && (node.matches?.(CARD_SELECTOR + ', [data-melco-wishlist-open]') || node.querySelector?.(CARD_SELECTOR + ', [data-melco-wishlist-open]'))))) schedule();
    });
    observer.observe(document.body, {childList: true, subtree: true});
    window.addEventListener('storage', event => {
      if (event.key !== KEY && event.key !== null) return;
      saved = decode(event.newValue);
      refreshButtons();
      if (dialog.open) renderList();
    });
    document.addEventListener('shopify:section:load', schedule);
    window.MelcoWishlist = Object.freeze({refresh: schedule});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
